import ProductTag from '@pages/ProductListing/view/components/ProductTag';
import React, { useEffect, useState } from 'react';
import CustomInput from '@common/components/CustomInput';
import { Accordion, AccordionSummary, AccordionDetails, Modal, Box } from '@mui/material';
import { inrFormat } from '@common/utils/formatCurrency';
import CustomRadio from '@common/components/CustomRadio';
import CustomCounterWidget from '@common/components/CustomCounterWidget';
import Share from '../../../../../common/components/Share';
import { addUpdateCart, applyRemoveCoupon, checkDeliveryEstimate, checkProductInWishlist, getAddresses, getAuthHeaders, getDeliveryAuthHeaders } from '@common/utils/cart';
import { useNavigate } from 'react-router-dom';
import IconText from '@common/components/IconText';
import axiosInstance from '@common/utils/axiosInstance';
import apiUrl from '@common/utils/apiURL';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useProductStatus } from 'hooks/useProductStatus';
import { useProductActions } from 'hooks/useProductActions';
import { AdvancedImage } from '@cloudinary/react';
import { Cloudinary } from "@cloudinary/url-gen";
import { format } from '@cloudinary/url-gen/actions/delivery';
import { isUserLoggedIn } from '@common/utils/auth/authService';
import { openSignInModal } from 'store/slices/authSlice';
import { useDispatch } from 'react-redux';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
};

function DetailInfo({ data, productCartQty, setCartData, sizes, shades, setSelectedSize, setSelectedShade, selectedSize, selectedShade, couponList, cartData }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { getCartQuantity, getProductInStock, isInWishlist, isInCart, isStockLimitAvailable } = useProductStatus();
    const { toggleWishlist, addToCart, updateCartQuantity } = useProductActions();
    const [wishlistActive, setWishlistActive] = useState(isInWishlist(data?.id));

    const cld = new Cloudinary({
        cloud: {
            cloudName: 'dci1aiukm'
        }
    });

    useEffect(() => {
        setWishlistActive(isInWishlist(data?.id));
    }, [isInWishlist(data?.id)]);

    const itemProductQty = getCartQuantity(data?.id);
    // const itemProductStock = getProductInStock(data?.id);
    // const itemProductStock = data?.stock;
    const itemProductStock = 10000;

    useEffect(() => {
        setWishlistActive(checkProductInWishlist(data?.id));
    }, [data?.id]);

    const wishListActiveHandleChange = async (e, productId, type) => {
        e.preventDefault();
        if (isUserLoggedIn()) {
            toggleWishlist(productId, type);
        } else {
            dispatch(openSignInModal());
        }
    };

    //color handle and State
    const [colorState, setColorState] = useState(null);
    const colorHandleChange = (title) => {
        setColorState(title);
    }

    // share option modal state
    const [shareOptionModal, setShareOptionModal] = useState(false);
    const handleOpenShareOptionModal = () => {
        setShareOptionModal(true)
    }
    const handleCloseShareOptionModal = () => {
        setShareOptionModal(false)
    }

    // size handle and State
    const [sizeState, setSizeState] = useState(null);
    const sizeHandleChange = (size) => {
        setSizeState(size);
    }

    // size chart modal state
    const [sizeChartModal, setSizeChartModal] = useState(false);
    const handleOpenSizeChartModal = () => {
        setSizeChartModal(true)
    }
    const handleCloseSizeChartModal = () => {
        setSizeChartModal(false)
    }

    const sizeChartImage = cld.image('size-chart').quality('auto').delivery(format('webp'));

    // features data
    const [featuresData, setFeaturesData] = useState([]);
    useEffect(() => {
        setFeaturesData(data?.features.split(','));
    }, [data.features]);

    // cart qty state
    const [qty, setQty] = useState(1);
    // const [qty, setQty] = useState(itemProductQty);

    // useEffect(() => {
    //     setQty(itemProductQty === 0 ? 1 : itemProductQty);
    // }, [itemProductQty]);

    useEffect(() => {
        if (itemProductQty !== qty) {
            // updateCartQuantity(data?.id, qty);
        }
    }, [qty]);

    // select coupon on pdp
    const [selectedCoupon, setSelectedCoupon] = useState(cartData?.price?.couponCode || ''); // Track the selected coupon

    const handleCouponSelection = (code) => {
        // console.log('Radio button clicked:', code); // Debug log
        if (selectedCoupon === code) {
            setSelectedCoupon(null); // Uncheck the selected coupon
            updateCart(null);
            // console.log('Coupon unselected');
        } else {
            setSelectedCoupon(code); // Update the selected coupon
            updateCart(code);
            // console.log('Coupon selected:', code);
        }
    };

    const updateCart = async (param) => {
        try {
            const updatedCart = await applyRemoveCoupon(param); // Await the promise returned by getCart
            // console.log('cart', updatedCart);
            if (updatedCart) {
                setCartData(updatedCart?.data);
            }
        } catch (error) {
            console.error('Error update cart:', error);
        }
    };

    function itext(inputStr) {

        return inputStr
            .toLowerCase()                       // Convert to lowercase
            .replace(/[^a-z0-9\s]/g, '')         // Remove special characters (keep letters, numbers, spaces)
            .trim()                              // Remove leading/trailing spaces
            .replace(/\s+/g, '-');               // Replace one or more spaces with a hyphen
    }

    // Check delivery estimates
    const [deliveryEstimateHelperText, setDeliveryEstimateHelperText] = useState('')
    const [addressData, setAddressData] = useState([])
    useEffect(() => {
        fetchAddresses()
    }, [])

    const fetchAddresses = async () => {
        try {
            const addresses = await getAddresses() // Await the promise returned by getCart
            if (addresses) {
                setAddressData(addresses?.data)
            }
        } catch (error) {
            console.error("Error fetching address:", error)
        }
    }

    const [pinCode, setPinCode] = useState('');
    const handleCheckDelivery = async (param, flowRef = '') => {
        checkDeliveryEstimate(param, setDeliveryEstimateHelperText)
    }

    useEffect(() => {
        if (deliveryEstimateHelperText === '') {
            if (localStorage.getItem('selected_pincode')) {
                setPinCode(localStorage.getItem('selected_pincode'));
                handleCheckDelivery(localStorage.getItem('selected_pincode'));
            } else if (addressData?.length > 0) {
                let tempPinCode = addressData.find((item) => item.isDefault)?.pincode;
                setPinCode(tempPinCode);
                localStorage.setItem('selected_pincode', tempPinCode);
                handleCheckDelivery(tempPinCode);
            }
        }
    }, [addressData])

    const proceedToCart = () => {
        addToCart(data?.id, 1, true)
        // setTimeout(() => {
        //     navigate('/cart')
        // }, 1000)
    }

    function PackageList({ description }) {
        const getListFromDescription = (desc) => {
          if (!desc) return [];
      
          // Extract text inside <b>...</b>
          const boldMatch = desc.match(/<b>(.*?)<\/b>/i);
          const boldText = boldMatch ? boldMatch[1] : '';
      
          // Get the part after the colon
          const parts = boldText.split(':');
          if (parts.length < 2) return [];
      
          const afterColon = parts[1];
      
          // Split by commas and trim
          return afterColon
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item); // remove empty strings
        };
      
        const items = getListFromDescription(description);
      
        return (
          <ul className='bs-detail-info__bullet-point-list'>
            {items.map((item, index) => (
              <li key={index} className='bs-detail-info__bullet-point-item'>
                <p className='bs-detail-info__bullet-point'>{item}</p>
              </li>
            ))}
          </ul>
        );
    }
      

    console.log('itemProductQty', itemProductQty, itemProductStock);
    return (
        <>
            <div className='bs-detail-info'>
                <ul className='bs-detail-info__section-wrap'>
                    <li className='bs-detail-info__section-item'>
                        <label className='bs-detail-info__label'>{data?.sapCategoryName}</label>
                        <div className='bs-detail-info__title-wrap'>
                            <h1 className='bs-detail-info__title'>{data?.name}</h1>
                            {/* {isUserLoggedIn() && */}
                            <button
                                className='bs-detail-info__btn-like'
                                onClick={(e) => {
                                    wishListActiveHandleChange(
                                        e,
                                        data?.id,
                                        wishlistActive ? true : false
                                    );
                                }}
                            >
                                <span className={`icon  ${wishlistActive ? 'icon-like-fill' : 'icon-like'} bs-detail-info__icon-like`}></span>
                            </button>
                            {/* } */}
                        </div>
                        <ul className='bs-detail-info__feature-list'>
                            <li className='bs-detail-info__feature-item'>
                                <label className='bs-detail-info__feature-label'>{data?.fabType}</label>
                            </li>
                            <li className='bs-detail-info__feature-item'>
                                <label className='bs-detail-info__feature-label'>{data?.sapCollectionName}</label>
                            </li>
                        </ul>
                        <div className='bs-detail-info__price-info-wrap'>
                            <div className='bs-product-tile__price-wrap bs-detail-info__price-wrap'>
                                <strong className='bs-product-tile__price bs-detail-info__price'>{inrFormat(data?.discount ? Number(data?.price) - Number(data?.discount) : Number(data?.price))}</strong>
                                {data?.discount && <strong className='bs-product-tile__price bs-product-tile__price--strike bs-detail-info__price bs-detail-info__price--strike'>{inrFormat(Number(data?.price))}</strong>}
                            </div>
                            {data?.discount && <ProductTag
                                title={'20%Off'}
                                classname="bs-detail-info__tag"
                            />}
                            <p className='bs-detail-info__text'>Inc. All Taxes</p>
                        </div>
                        <div className='bs-checkbox-wrap'>
                            {couponList.length > 0 &&
                                couponList.map((coupon, index) => (<>
                                    <div className="bs-checkbox bs-detail-info__accept-coupon" key={index}>
                                        <input
                                            type="radio"
                                            id={`coupon_${index}`}
                                            name="coupon"
                                            checked={selectedCoupon === coupon.couponCode}
                                            // onChange={() => handleCouponSelection(coupon?.couponCode)} // Handles selection when value changes
                                            onClick={() => handleCouponSelection(coupon?.couponCode)} // Handles click even if already selected
                                        />
                                        <label
                                            className="bs-checkbox__label bs-detail-info__accept-coupon-label"
                                            htmlFor={`coupon_${index}`}
                                        >
                                            {`Apply coupon '${coupon?.couponCode}' & Get it For ${inrFormat(
                                                Number(data?.price) - Number(coupon?.discount)
                                            )}`}
                                        </label>
                                    </div>
                                </>))
                            }
                        </div>
                    </li>
                    <li className='bs-detail-info__section-item'>
                        <div className='bs-detail-info__section-title-wrap'>
                            <p className='bs-detail-info__info-text'>
                                <span className='bs-detail-info__info-text-label'>size</span>
                                <span className='bs-detail-info__info-text-txt'>{selectedSize} : {data?.dimensions}</span>
                            </p>
                            <button className='bs-btn bs-btn__btn-icon-text bs-detail-info__size-chart-action' onClick={handleOpenSizeChartModal}>
                                <span className='icon icon-ruler bs-btn__btn-icon-text bs-btn__btn-icon'></span>
                                <span className='btn-btn__btn-icon-text bs-btn__btn-text'>all sizes</span>
                            </button>
                        </div>
                        <div className='bs-detail-info__section-action-wrap'>
                            <ul className='lyt-radio-list'>
                                {sizes.map((item, index) => {
                                    return (
                                        <li className='lyt-radio-list__item' key={index}>
                                            <CustomRadio
                                                title={item}
                                                groupName='size'
                                                itemId={`${item}__${index}`}
                                                onChange={() => setSelectedSize(item)}
                                                defaultValue={selectedSize}
                                            />
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </li>
                    <li className='bs-detail-info__section-item'>
                        <div className='bs-detail-info__section-title-wrap'>
                            <p className='bs-detail-info__info-text'>
                                <span className='bs-detail-info__info-text-label'>color</span>
                                <span className='bs-detail-info__info-text-txt bs-detail-info__info-text-txt--typ-upppercase'>{selectedShade}</span>
                            </p>
                        </div>
                        <div className='bs-detail-info__section-action-wrap'>
                            <ul className='lyt-radio-list'>
                                {shades.map((item, index) => {
                                    return (
                                        <li className='lyt-radio-list__item' key={index}>
                                            <CustomRadio
                                                title={item.shade}
                                                groupName='colors'
                                                variant='color'
                                                colorValue={item.imageUrl}
                                                itemId={`${item.title}__${index}`}
                                                onChange={() => setSelectedShade(item.shade)}
                                                // onChange={() => navigate(`/product-description/${item.slug}`)}
                                                defaultValue={selectedShade}
                                            />
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </li>
                    <li className='bs-detail-info__section-item'>
                        <div className='bs-detail-info__section-title-wrap'>
                            <p className='bs-detail-info__info-text'>
                                <span className='bs-detail-info__info-text-label'>Package Contains</span>
                            </p>
                        </div>
                        <div className='bs-detail-info__section-action-wrap'>
                            <PackageList description={data?.description} />
                            {/* <ul className='bs-detail-info__bullet-point-list'>
                                <li className='bs-detail-info__bullet-point-item'>
                                    <p className='bs-detail-info__bullet-point'>1 QUILTED BEDSPREAD (228X274 CMS)</p>
                                </li>
                                <li className='bs-detail-info__bullet-point-item'>
                                    <p className='bs-detail-info__bullet-point'>1 BEDHEET (274X274CMS)</p>
                                </li>
                                <li className='bs-detail-info__bullet-point-item'>
                                    <p className='bs-detail-info__bullet-point'>4 PILLOW COVERS (46X68 CMS)</p>
                                </li>
                            </ul> */}
                        </div>
                    </li>
                    <li className='bs-detail-info__section-item'>
                        {!isInCart(data?.id) && data?.stock <= '0' ? <>
                            <div className='bs-detail-info__section-title-wrap'>
                                <p className='bs-detail-info__info-text'>
                                    Currently Out of Stock, Coming Soon.
                                </p>
                            </div>
                        </> : <>
                            <div className='bs-detail-info__section-title-wrap'>
                                <p className='bs-detail-info__info-text'>
                                    <span className='bs-detail-info__info-text-label'>Quantity</span>
                                </p>
                                <CustomCounterWidget count={qty} setCount={setQty} stock={itemProductStock} flowRef="pdp" />
                            </div>
                            <div className='bs-detail-info__section-action-wrap bs-detail-info__cta-wrap'>
                                <button
                                    className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border'
                                    onClick={() => {
                                        // productCartQty === 0 ? addToCart(data?.id, 1) : updateCartQuantity(data?.id, qty) 
                                        const tempProductCartQty = getCartQuantity(data?.id);
                                        const count = tempProductCartQty + (tempProductCartQty === 0 ? qty : qty);
                                        const productStock = isInCart(data?.id) ? getProductInStock(data?.id) : data?.stock;
                                        if (isStockLimitAvailable(productStock, count)) {
                                            addToCart(data?.id, count)
                                        } else {
                                            toast.error(`Only ${productStock} available in stock`);
                                        }
                                    }}
                                >
                                    add to cart
                                </button>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' onClick={() => { !isInCart(data?.id) ? proceedToCart() : navigate('/cart') }}>buy now</button>
                                <button className='bs-btn bs-btn__btn-icon-solid bs-btn__btn-icon-solid--typ-xxl'>
                                    <span className='bs-btn__icon icon icon-share'></span>
                                    <span className='bs-btn__btn-text' onClick={handleOpenShareOptionModal} >share</span>
                                </button>
                            </div>
                        </>}
                    </li>
                    <li className='bs-detail-info__section-item'>
                        <div className='bs-detail-info__section-title-wrap'>
                            <p className='bs-detail-info__info-text'>
                                <span className='bs-detail-info__info-text-label bs-detail-info__info-text-label--light'>check delivery</span>
                                {/* <span className='bs-detail-info__info-text-txt bs-detail-info__info-text-txt--sm'><span className='icon icon-check-circle bs-detail-info__ckeck-icon'></span>COD Available</span> */}
                            </p>
                        </div>
                        <div className='bs-detail-info__section-action-wrap'>
                            <CustomInput
                                helperText={deliveryEstimateHelperText}
                                iconName='icon-delivery'
                                inputData={pinCode || ''}
                                handleBtnClick={handleCheckDelivery}
                                reference="deliveryode"
                            />
                        </div>
                    </li>
                    <li className='bs-detail-info__section-item'>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<span className='icon icon-down'></span>}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='bs-detail-info__section-title-wrap'
                            >
                                <p className='bs-detail-info__info-text-label bs-detail-info__info-text-label--light'>product features</p>
                            </AccordionSummary>
                            <AccordionDetails className='bs-detail-info__section-action-wrap'>
                                {/* <p className='bs-detail-info__info-text-txt bs-detail-info__info-text-txt--sm'>Sansaar’s vision is to redefine the art of home living by blending timeless design with unparalleled comfort, quality, and sustainability.</p> */}
                                <div className='bs-infography-footprint'>
                                    <ul className='bs-infography-footprint__feature-list'>
                                        {featuresData.length > 0 && featuresData.map((item, index) => {

                                            const myImage = cld.image(itext(item)).quality('auto').delivery(format('svg'));

                                            return (
                                                item &&
                                                <li className='bs-infography-footprint__feature-item' key={index}>
                                                    <span className='bs-infography-footprint__icon-wrap'>
                                                        {/* <span className={`icon icon-${itext(item)}`}></span> */}
                                                        {/* <img src={`assets/images/icon/${itext(item)}.svg`} alt={item}/> */}
                                                        <AdvancedImage cldImg={myImage} loading="lazy" className='bs-product-tile__image' />
                                                    </span>
                                                    <p className='bs-infography-footprint__feature'>{item}</p>
                                                </li>
                                            )
                                        }
                                        )}
                                    </ul>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </li>
                    <li className='bs-detail-info__section-item'>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<span className='icon icon-down'></span>}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='bs-detail-info__section-title-wrap'
                            >
                                <p className='bs-detail-info__info-text-label bs-detail-info__info-text-label--light'>wash care</p>
                            </AccordionSummary>
                            <AccordionDetails className='bs-detail-info__section-action-wrap'>
                                <ul className='bs-detail-info__icon-list'>
                                    {data?.bleachWash !== '0' && data?.bleachWash !== null ?
                                        <li className='bs-detail-info__icon-list-item'>
                                            <IconText
                                                icon='no-bleach'
                                                title={data?.bleachWash}
                                                classname='bs-detail-info__icon-text'
                                            />
                                        </li>
                                    : null}
                                    {data?.dryCleanWash !== '0' && data?.dryCleanWash !== null ?
                                        <li className='bs-detail-info__icon-list-item'>
                                            <IconText
                                                icon='dry-clean'
                                                title={data?.dryCleanWash}
                                                classname='bs-detail-info__icon-text'
                                            />
                                        </li>
                                    : null}
                                    {data?.iron !== '0' && data?.iron !== null ?
                                        <li className='bs-detail-info__icon-list-item'>
                                            <IconText
                                                icon={data?.iron === 'Do Not Iron' ? 'no-iron' : data?.iron === 'Medium Iron' ? 'iron-medium' : 'iron'}
                                                title={data?.iron}
                                                classname='bs-detail-info__icon-text'
                                            />
                                        </li>
                                        : null}
                                    {data?.machineWash !== '0' && data?.machineWash !== null ?
                                        <li className='bs-detail-info__icon-list-item'>
                                            <IconText
                                                icon={
                                                    data?.machineWash === 'Machine Wash At 30 Degree Celcius' ? 'wash-30' : 
                                                    data?.machineWash === 'Machine Wash At 40 Degree Celcius' ? 'wash-40' : 
                                                    data?.machineWash === 'Do Not Wash' ? 'no-wash' : 'no-wash'
                                                }
                                                title={data?.machineWash}
                                                classname='bs-detail-info__icon-text'
                                            />
                                        </li>
                                    : null}
                                    {data?.tumbleDryWash !== '0' && data?.tumbleDryWash !== null ?
                                        <li className='bs-detail-info__icon-list-item'>
                                            <IconText
                                                icon={
                                                    data?.tumbleDryWash === 'Tumble Dry Low' ? 'tumble-dry-low' : 
                                                    data?.tumbleDryWash === 'Tumble Dry Medium Heat' ? 'tumble-dry-medium' : 
                                                    data?.tumbleDryWash === 'Do Not Tumble Dry' ? 'no-tumble-dry' : 'no-tumble-dry'
                                                }
                                                title={data?.tumbleDryWash}
                                                classname='bs-detail-info__icon-text'
                                            />
                                        </li>
                                    : null}

                                    {/* {data?.washCycle !== '0' && data?.washCycle !== null ?
                                        <li className='bs-detail-info__icon-list-item'>
                                            <IconText
                                                icon='wash-30'
                                                title={data?.washCycle}
                                                classname='bs-detail-info__icon-text'
                                            />
                                        </li>
                                        : null} */}
                                </ul>
                            </AccordionDetails>
                        </Accordion>
                    </li>
                    <li className='bs-detail-info__section-item'>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<span className='icon icon-down'></span>}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='bs-detail-info__section-title-wrap'
                            >
                                <p className='bs-detail-info__info-text-label bs-detail-info__info-text-label--light'>description</p>
                            </AccordionSummary>
                            <AccordionDetails className='bs-detail-info__section-action-wrap'>
                                <p className='bs-detail-info__info-text__desc' dangerouslySetInnerHTML={{ __html: data?.description }}></p>
                            </AccordionDetails>
                        </Accordion>
                    </li>
                    <li className='bs-detail-info__section-item'>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<span className='icon icon-down'></span>}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className='bs-detail-info__section-title-wrap'
                            >
                                <p className='bs-detail-info__info-text-label bs-detail-info__info-text-label--light'>return & exchange</p>
                            </AccordionSummary>
                            <AccordionDetails className='bs-detail-info__section-action-wrap'>
                                {/* <p className='bs-detail-info__info-text__subtitle'>80% Cotton, 20% Polyster</p> */}
                                <p className='bs-detail-info__info-text__desc'>Returns and Replacements available for damaged products or manufacturing defects within 7 days of delivery. Order cancellations applicable only for orders that are not dispatched. Write to us on support@sansaar.co.in or call our customer care at Ph: +91 8655712561 for any return, refund or cancellation request</p>
                            </AccordionDetails>
                        </Accordion>
                    </li>

                </ul>
            </div>
            <Modal
                open={shareOptionModal}
                onClose={handleCloseShareOptionModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='bs-modal bs-modal--typ-sm'
            >
                <Box className='bs-modal__wrapper' sx={style}>
                    <div className='bs-modal__content'>
                        <button className='bs-modal__close' onClick={handleCloseShareOptionModal}>
                            <span className='icon icon-simple-close'></span>
                        </button>
                        <Share imageId={data?.imageUrl} name={data?.name} />
                    </div>
                </Box>
            </Modal>

            <Modal
                open={sizeChartModal}
                onClose={handleCloseSizeChartModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='bs-modal bs-modal--typ-img'
            >
                <Box className='bs-modal__wrapper' sx={style}>
                    <div className='bs-modal__content'>
                        <button className='bs-modal__close' onClick={handleCloseSizeChartModal}>
                            <span className='icon icon-simple-close'></span>
                        </button>
                        <div className='bs-modal__head-wrap'>
                            <h2 className='bs-modal__title'>All sizes</h2>
                        </div>
                        <AdvancedImage cldImg={sizeChartImage} loading="lazy" className='bs-product-tile__image' />
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default DetailInfo